"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var config_1 = require("../config");
var next_1 = require("@alifd/next");
var Cookie = require("js-cookie");
var task_1 = require("@alife/task");
var drive_1 = require("./drive");
var contextManage_1 = require("../contextManage");
var IDCard = function () {
    // tslint:disable-next-line:prefer-const
    var timer = null;
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    // 初始化就开始加载驱动脚本
    react_1.useEffect(function () {
        var deviceStatus = task_1.Util.getDeviceStatus();
        if (!deviceStatus.idCard) {
            //没有链接的唤起设备管理
            if (self !== top) {
                var data = {
                    type: 'deviceConnect',
                    data: 'idCard',
                };
                window.top.postMessage(data, '*');
                //关闭弹窗
                context.closeDialog();
                return;
            }
        }
        var deviceType = Cookie.get("IdCardType") || "";
        if (!deviceType) {
            console.error("设备型号");
            return;
        }
        if (timer) {
            window.clearInterval(timer);
            timer = null;
        }
        timer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var uniqueDeviceTag, module, info, isOnly, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        uniqueDeviceTag = task_1.Util.encode({
                            hallId: Cookie.get("departmentId") || "",
                            type: "idCard",
                            deviceType: deviceType,
                        });
                        return [4 /*yield*/, drive_1.getIsvModule(uniqueDeviceTag)];
                    case 1:
                        module = _a.sent();
                        if (!module) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, module.get_info()];
                    case 2:
                        info = _a.sent();
                        if (info) {
                            isOnly = context.only;
                            clearInterval(timer);
                            // 修改状态为手工登录
                            context.setCardName(info.cardName);
                            context.setCardNumber(info.cardNumber);
                            context.setProgress(config_1.PROCESS.success);
                            isOnly ? context.success(info) : context.setStatus(config_1.TASKTYPE.manualLogin); //如果传了only为true ，不进行手动回写。
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        next_1.Message.error("读卡器出错");
                        clearInterval(timer);
                        context.fail();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, 1500);
        return function () {
            // 清楚定时器
            if (timer) {
                window.clearInterval(timer);
                timer = null;
            }
        };
    }, []);
    if (context.progress === config_1.PROCESS.pending) {
        return (React.createElement("div", { className: "lobby_idcard_dialog_wap" },
            React.createElement("div", { className: "status", key: 1 },
                "\u8BF7\u63D0\u9192\u529E\u4E8B\u4EBA\u5C06\u8EAB\u4EFD\u8BC1\u653E\u7F6E\u5230\u8BFB\u5361\u5668\u4E0A\uFF0C\u8FDB\u884C\u5FEB\u901F\u8BA4\u8BC1\u3002",
                " ",
                React.createElement("span", { className: "noCard", onClick: function () { context.setStatus(config_1.TASKTYPE.manualLogin); } }, "\u6CA1\u6709\u8EAB\u4EFD\u8BC1")),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("div", { className: "pending_bg_image" }))));
    }
    else if (context.progress === config_1.PROCESS.success) {
        return (React.createElement("div", { className: "lobby_idcard_dialog_wap" },
            React.createElement("div", { className: "status1", key: 1 }, "\u8EAB\u4EFD\u4FE1\u606F\u8BC6\u522B\u6210\u529F\uFF01"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("div", { className: "success_bg_image" }))));
    }
    return React.createElement("div", null);
};
exports.default = IDCard;
